import { useTranslation } from 'react-i18next';
import { DeleteButton } from '../../../../../components/buttons/DeleteButton';
import { DateTimePicker } from '../../../../../components/dateTimePicker/DateTimePicker';
import { DEFAULT_DATE_TIME } from '../../../../../components/common/Constants';
import { toDateString } from '../../../../../utils/TimeUtils';

export const CompleteOrderFormTable = ({ products, onRemove }) => {

    const { t } = useTranslation('order');

    const setValue = (value, product) => {
        product.expiredDate = toDateString(value, DEFAULT_DATE_TIME);
    };

    return (
        <div className={'completed-order-products-table'}>
            <table>
                <thead>
                <tr>
                    <th className={'td'}>{t('form.product')}</th>
                    <th className={'td'} width={'20%'}>{t('form.amount')}</th>
                    <th className={'td'} width={'20%'}>{t('warehouse:price')}</th>
                    <th className={'td'} width={'30%'}>{t('warehouse:expiredDate')}</th>
                    <th className={'td'}></th>
                </tr>
                </thead>
                <tbody>
                {products == null || products.length === 0 ? <></> : products.map((product, index) => {
                    return (
                        <tr key={index}>
                            <td className={'td'}>{product.title}</td>
                            <td className={'td input-cell'}>
                                <input type={'number'}
                                       className={'form-control'}
                                       id={'amount-' + index}
                                       defaultValue={product.amount}
                                       onChange={(event) => product.amount = +event.target.value} />
                            </td>
                            <td className={'td input-cell'}>
                                <input type={'number'}
                                       className={'form-control'}
                                       id={'price-' + index}
                                       defaultValue={product.price}
                                       onChange={(event) => product.price = +event.target.value} />
                            </td>
                            <td className={'td input-cell'}>
                                <DateTimePicker value={product.expiredDate}
                                                onChange={(value) => setValue(value, product)}
                                                dateFormat={DEFAULT_DATE_TIME}
                                                showTime={true}>
                                </DateTimePicker>
                            </td>
                            <td className={'td'}>
                                <DeleteButton onClick={() => onRemove(index)} />
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};